import { render, staticRenderFns } from "./event-countdown.vue?vue&type=template&id=5a870afd&scoped=true&"
import script from "./event-countdown.vue?vue&type=script&lang=js&"
export * from "./event-countdown.vue?vue&type=script&lang=js&"
import style0 from "./event-countdown.vue?vue&type=style&index=0&id=5a870afd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a870afd",
  null
  
)

export default component.exports